import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e4832f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "cont-nav" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "cont-nav" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "map"
}
const _hoisted_7 = { class: "block1" }
const _hoisted_8 = {
  class: "no-before",
  style: {"width":"114px"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "净资产收益率", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "vertical" })
], -1))
const _hoisted_11 = { class: "block2" }
const _hoisted_12 = { style: {"width":"114px"} }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "总资产净利率", -1))
const _hoisted_14 = {
  class: "no-after",
  style: {"width":"212px"}
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "归属母公司股东的净利润占比", -1))
const _hoisted_16 = { style: {"width":"114px"} }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "权益乘数", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "vertical" })
], -1))
const _hoisted_19 = { class: "block3" }
const _hoisted_20 = { style: {"width":"114px"} }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "营业净利润率", -1))
const _hoisted_22 = { style: {"width":"114px"} }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "总资产周转率", -1))
const _hoisted_24 = {
  class: "no-before",
  style: {"width":"114px"}
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "资产负债率", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon1" }, "×"),
  /*#__PURE__*/_createElementVNode("span", { class: "icon2" }, "1÷(1﹣"),
  /*#__PURE__*/_createElementVNode("span", { class: "icon3" }, ")")
], -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "vertical" }),
  /*#__PURE__*/_createElementVNode("span", { class: "vertical" }),
  /*#__PURE__*/_createElementVNode("span", { class: "vertical" })
], -1))
const _hoisted_28 = { class: "block4" }
const _hoisted_29 = { style: {"width":"114px"} }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "净利润", -1))
const _hoisted_31 = {
  class: "no-after",
  style: {"width":"114px"}
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "营业总收入", -1))
const _hoisted_33 = {
  class: "no-after",
  style: {"width":"114px"}
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "营业总收入", -1))
const _hoisted_35 = { style: {"width":"114px"} }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "资产总额", -1))
const _hoisted_37 = {
  class: "no-after",
  style: {"width":"114px"}
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "负债总额", -1))
const _hoisted_39 = {
  class: "no-after",
  style: {"width":"114px"}
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "资产总额", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon4" }, "÷"),
  /*#__PURE__*/_createElementVNode("span", { class: "icon5" }, "÷"),
  /*#__PURE__*/_createElementVNode("span", { class: "icon6" }, "÷")
], -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "vertical" }),
  /*#__PURE__*/_createElementVNode("span", { class: "vertical" })
], -1))
const _hoisted_43 = { class: "block5" }
const _hoisted_44 = { style: {"width":"114px"} }
const _hoisted_45 = /*#__PURE__*/_createTextVNode("收入总额 ")
const _hoisted_46 = { style: {"width":"114px"} }
const _hoisted_47 = /*#__PURE__*/_createTextVNode("成本总额 ")
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_49 = {
  class: "no-before",
  style: {"width":"114px"}
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "流动资产", -1))
const _hoisted_51 = { style: {"width":"114px"} }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "非流动资产", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon7" }, "﹣"),
  /*#__PURE__*/_createElementVNode("span", { class: "icon8" }, "+")
], -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line5" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "vertical" }),
  /*#__PURE__*/_createElementVNode("span", { class: "vertical" })
], -1))
const _hoisted_56 = { class: "block6" }
const _hoisted_57 = {
  class: "no-after no-before",
  style: {"width":"142px"}
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "营业总收入", -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "公允价值变动收益", -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "营业外收入", -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "投资收益", -1))
const _hoisted_62 = {
  class: "no-after",
  style: {"width":"128px"}
}
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "营业成本", -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "营业税金及附加", -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "所得税费用", -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "资产减值损失", -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "营业外支出", -1))
const _hoisted_68 = {
  class: "no-after",
  style: {"width":"114px"}
}
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "期间费用", -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cover" }, null, -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "财务费用", -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "销售费用", -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "管理费用", -1))
const _hoisted_74 = {
  class: "no-after no-before",
  style: {"width":"128px"}
}
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "货币资金", -1))
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "交易性金融资产", -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "应收账款", -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "预付账款", -1))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "其他应收款", -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "存货", -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "其他流动资产", -1))
const _hoisted_82 = {
  class: "no-after no-before",
  style: {"width":"142px"}
}
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "可供出售金融资产", -1))
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "持有至到期投资", -1))
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "长期股权投资", -1))
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "投资性房地产", -1))
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "固定资产", -1))
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "在建工程", -1))
const _hoisted_89 = {
  class: "no-after",
  style: {"width":"128px"}
}
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "无形资产", -1))
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "开发支出", -1))
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "商誉", -1))
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "长期待摊费用", -1))
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "递延所得税", -1))
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "其他非流动资产", -1))
const _hoisted_96 = {
  key: 1,
  class: "map map2"
}
const _hoisted_97 = { class: "block1" }
const _hoisted_98 = {
  class: "no-before",
  style: {"width":"114px"}
}
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "净资产收益率", -1))
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "vertical" })
], -1))
const _hoisted_101 = { class: "block2" }
const _hoisted_102 = { style: {"width":"114px"} }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "总资产净利率", -1))
const _hoisted_104 = {
  class: "no-after",
  style: {"width":"212px"}
}
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "归属母公司股东的净利润占比", -1))
const _hoisted_106 = { style: {"width":"114px"} }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "权益乘数", -1))
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "vertical" })
], -1))
const _hoisted_109 = { class: "block3" }
const _hoisted_110 = { style: {"width":"114px"} }
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "营业净利润率", -1))
const _hoisted_112 = { style: {"width":"114px"} }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "总资产周转率", -1))
const _hoisted_114 = {
  class: "no-before",
  style: {"width":"114px"}
}
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "资产负债率", -1))
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon1" }, "×"),
  /*#__PURE__*/_createElementVNode("span", { class: "icon2" }, "1÷(1﹣"),
  /*#__PURE__*/_createElementVNode("span", { class: "icon3" }, ")")
], -1))
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "vertical" }),
  /*#__PURE__*/_createElementVNode("span", { class: "vertical" }),
  /*#__PURE__*/_createElementVNode("span", { class: "vertical" })
], -1))
const _hoisted_118 = { class: "block4" }
const _hoisted_119 = { style: {"width":"114px"} }
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "净利润", -1))
const _hoisted_121 = {
  class: "no-after",
  style: {"width":"114px"}
}
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "营业总收入", -1))
const _hoisted_123 = {
  class: "no-after",
  style: {"width":"114px"}
}
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "营业总收入", -1))
const _hoisted_125 = { style: {"width":"114px"} }
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "资产总额", -1))
const _hoisted_127 = {
  class: "no-after",
  style: {"width":"114px"}
}
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "负债总额", -1))
const _hoisted_129 = {
  class: "no-after",
  style: {"width":"114px"}
}
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "资产总额", -1))
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon4" }, "÷"),
  /*#__PURE__*/_createElementVNode("span", { class: "icon5" }, "÷"),
  /*#__PURE__*/_createElementVNode("span", { class: "icon6" }, "÷")
], -1))
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "vertical" })
], -1))
const _hoisted_133 = { class: "block5" }
const _hoisted_134 = { style: {"width":"114px"} }
const _hoisted_135 = /*#__PURE__*/_createTextVNode("收入总额 ")
const _hoisted_136 = { style: {"width":"114px"} }
const _hoisted_137 = /*#__PURE__*/_createTextVNode("成本总额 ")
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "no-before no-after" }, [
  /*#__PURE__*/_createElementVNode("span", null, "金融企业（银行、证券、保险）不适用流动资产和非流动资产")
], -1))
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon7" }, "﹣")
], -1))
const _hoisted_142 = { class: "block6" }
const _hoisted_143 = {
  class: "no-after no-before",
  style: {"width":"156px"}
}
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "利息净收入", -1))
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "手续费及佣金净收入", -1))
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "投资收益", -1))
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "公允价值变动收益", -1))
const _hoisted_148 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "汇兑收益", -1))
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "资产处置收益", -1))
const _hoisted_150 = {
  class: "no-after no-before",
  style: {"width":"114px"}
}
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "税金及附加", -1))
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "业务及管理费", -1))
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "资产减值损失", -1))
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "所得税费用", -1))
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "注：以上数据优先摘录上市公司定期报告中公布的数据，若报告期中没公布此项数据，则通过计算得出此项数据。", -1))
const _hoisted_156 = {
  key: 1,
  style: {"height":"62px","min-height":"62px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoCircleOutlined = _resolveComponent("InfoCircleOutlined")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_Nodata = _resolveComponent("Nodata")!

  return (_ctx.currentData && Object.keys(_ctx.currentData).length)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("nav", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags1, (tag, idx) => {
            return (_openBlock(), _createElementBlock("span", {
              key: idx,
              class: _normalizeClass({ active: tag.value === _ctx.activeTagVal1 }),
              onClick: ($event: any) => (_ctx.checkTag1(tag))
            }, _toDisplayString(tag.label), 11, _hoisted_3))
          }), 128))
        ]),
        _createElementVNode("nav", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags2, (tag, idx) => {
            return (_openBlock(), _createElementBlock("span", {
              key: idx,
              class: _normalizeClass({ active: tag.value === _ctx.activeTagVal2 }),
              onClick: ($event: any) => (_ctx.checkTag2(tag))
            }, _toDisplayString(tag.label), 11, _hoisted_5))
          }), 128))
        ]),
        _createElementVNode("div", {
          class: "block",
          style: _normalizeStyle({height: _ctx.pageSourceData.EnterpriseType === 99? '866px' : '816px'})
        }, [
          (_ctx.pageSourceData.EnterpriseType === 99)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("ul", _hoisted_7, [
                  _createElementVNode("li", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("span", null, _toDisplayString(_ctx.currentData.ROEWeighted ? _ctx.currentData.ROEWeighted.toFixed(2)+'%' : '—'), 1)
                  ])
                ]),
                _hoisted_10,
                _createElementVNode("ul", _hoisted_11, [
                  _createElementVNode("li", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("span", null, _toDisplayString(_ctx.currentData.ROA ? _ctx.currentData.ROA.toFixed(2)+'%' : '—'), 1)
                  ]),
                  _createElementVNode("li", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("span", null, _toDisplayString(_ctx.currentData.NPCOwnersRatio ? _ctx.currentData.NPCOwnersRatio.toFixed(2)+'%' : '—'), 1)
                  ]),
                  _createElementVNode("li", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("span", null, _toDisplayString(_ctx.currentData.EquityMultipler ? _ctx.currentData.EquityMultipler.toFixed(2) : '—'), 1)
                  ])
                ]),
                _hoisted_18,
                _createElementVNode("ul", _hoisted_19, [
                  _createElementVNode("li", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("span", null, _toDisplayString(_ctx.currentData.OperateNPR ? _ctx.currentData.OperateNPR.toFixed(2)+'%' : '—'), 1)
                  ]),
                  _createElementVNode("li", _hoisted_22, [
                    _hoisted_23,
                    _createElementVNode("span", null, _toDisplayString(_ctx.currentData.TotalAssetTRate ? _ctx.currentData.TotalAssetTRate.toFixed(2)+'次' : '—'), 1)
                  ]),
                  _createElementVNode("li", _hoisted_24, [
                    _hoisted_25,
                    _createElementVNode("span", null, _toDisplayString(_ctx.currentData.DebtAssetsRatio ? _ctx.currentData.DebtAssetsRatio.toFixed(2)+'%' : '—'), 1)
                  ]),
                  _hoisted_26
                ]),
                _hoisted_27,
                _createElementVNode("ul", _hoisted_28, [
                  _createElementVNode("li", _hoisted_29, [
                    _hoisted_30,
                    _createElementVNode("span", null, _toDisplayString(_ctx.currentData.NetProfit ? _ctx.getNumber(_ctx.currentData.NetProfit) : '—'), 1)
                  ]),
                  _createElementVNode("li", _hoisted_31, [
                    _hoisted_32,
                    _createElementVNode("span", null, _toDisplayString(_ctx.currentData.TotalOperatingRevenue ? _ctx.getNumber(_ctx.currentData.TotalOperatingRevenue) : '—'), 1)
                  ]),
                  _createElementVNode("li", _hoisted_33, [
                    _hoisted_34,
                    _createElementVNode("span", null, _toDisplayString(_ctx.currentData.TotalOperatingRevenue ? _ctx.getNumber(_ctx.currentData.TotalOperatingRevenue) : '—'), 1)
                  ]),
                  _createElementVNode("li", _hoisted_35, [
                    _hoisted_36,
                    _createElementVNode("span", null, _toDisplayString(_ctx.currentData.TotalAssets ? _ctx.getNumber(_ctx.currentData.TotalAssets) : '—'), 1)
                  ]),
                  _createElementVNode("li", _hoisted_37, [
                    _hoisted_38,
                    _createElementVNode("span", null, _toDisplayString(_ctx.currentData.TotalLiability ? _ctx.getNumber(_ctx.currentData.TotalLiability) : '—'), 1)
                  ]),
                  _createElementVNode("li", _hoisted_39, [
                    _hoisted_40,
                    _createElementVNode("span", null, _toDisplayString(_ctx.currentData.TotalAssets ? _ctx.getNumber(_ctx.currentData.TotalAssets) : '—'), 1)
                  ]),
                  _hoisted_41
                ]),
                _hoisted_42,
                _createElementVNode("ul", _hoisted_43, [
                  _createElementVNode("li", _hoisted_44, [
                    _createElementVNode("span", null, [
                      _hoisted_45,
                      _createVNode(_component_a_popover, {
                        content: "收入总额=营业总收入+（其他收益+投资收益+汇兑收益+净敞口套期收益+公允价值变动收益+资产处置收益）+营业外收入",
                        trigger: "hover",
                        "arrow-point-at-center": "",
                        placement: "topLeft"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_InfoCircleOutlined, { style: {"margin-left":"6px"} })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("span", null, _toDisplayString(_ctx.currentData.TotalIncome ? _ctx.getNumber(_ctx.currentData.TotalIncome) : '—'), 1)
                  ]),
                  _createElementVNode("li", _hoisted_46, [
                    _createElementVNode("span", null, [
                      _hoisted_47,
                      _createVNode(_component_a_popover, {
                        content: "成本总额=营业总成本+资产减值损失+所得税费",
                        trigger: "hover",
                        "arrow-point-at-center": "",
                        placement: "topLeft"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_InfoCircleOutlined, { style: {"margin-left":"6px"} })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("span", null, _toDisplayString(_ctx.currentData.TotalCost ? _ctx.getNumber(_ctx.currentData.TotalCost) : '—'), 1)
                  ]),
                  _hoisted_48,
                  _createElementVNode("li", _hoisted_49, [
                    _hoisted_50,
                    _createElementVNode("span", null, _toDisplayString(_ctx.currentData.TotalCurrentAssets ? _ctx.getNumber(_ctx.currentData.TotalCurrentAssets) : '—'), 1)
                  ]),
                  _createElementVNode("li", _hoisted_51, [
                    _hoisted_52,
                    _createElementVNode("span", null, _toDisplayString(_ctx.currentData.TotalNonCurrentAssets ? _ctx.getNumber(_ctx.currentData.TotalNonCurrentAssets) : '—'), 1)
                  ]),
                  _hoisted_53,
                  _hoisted_54
                ]),
                _hoisted_55,
                _createElementVNode("ul", _hoisted_56, [
                  _createElementVNode("li", _hoisted_57, [
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", null, [
                        _hoisted_58,
                        _createElementVNode("span", null, _toDisplayString(_ctx.currentData.TotalOperatingRevenue ? _ctx.getNumber(_ctx.currentData.TotalOperatingRevenue) : '—'), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _hoisted_59,
                        _createElementVNode("span", null, _toDisplayString(_ctx.currentData.FairValueChangeIncome ? _ctx.getNumber(_ctx.currentData.FairValueChangeIncome) : '—'), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _hoisted_60,
                        _createElementVNode("span", null, _toDisplayString(_ctx.currentData.NonoperatingIncome ? _ctx.getNumber(_ctx.currentData.NonoperatingIncome) : '—'), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _hoisted_61,
                        _createElementVNode("span", null, _toDisplayString(_ctx.currentData.InvestIncome ? _ctx.getNumber(_ctx.currentData.InvestIncome) : '—'), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("li", _hoisted_62, [
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", null, [
                        _hoisted_63,
                        _createElementVNode("span", null, _toDisplayString(_ctx.currentData.OperatingCost ? _ctx.getNumber(_ctx.currentData.OperatingCost) : '—'), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _hoisted_64,
                        _createElementVNode("span", null, _toDisplayString(_ctx.currentData.OperatingTaxSurcharges ? _ctx.getNumber(_ctx.currentData.OperatingTaxSurcharges) : '—'), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _hoisted_65,
                        _createElementVNode("span", null, _toDisplayString(_ctx.currentData.IncomeTaxCost ? _ctx.getNumber(_ctx.currentData.IncomeTaxCost) : '—'), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _hoisted_66,
                        _createElementVNode("span", null, _toDisplayString(_ctx.currentData.AssetImpairmentLoss ? _ctx.getNumber(_ctx.currentData.AssetImpairmentLoss) : '—'), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _hoisted_67,
                        _createElementVNode("span", null, _toDisplayString(_ctx.currentData.NonoperatingExpense ? _ctx.getNumber(_ctx.currentData.NonoperatingExpense) : '—'), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("li", _hoisted_68, [
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", null, [
                        _hoisted_69,
                        _createElementVNode("span", null, _toDisplayString(_ctx.currentData.PeriodCosts ? _ctx.getNumber(_ctx.currentData.PeriodCosts) : '—'), 1)
                      ]),
                      _hoisted_70,
                      _createElementVNode("li", null, [
                        _hoisted_71,
                        _createElementVNode("span", null, _toDisplayString(_ctx.currentData.FinancialExpense ? _ctx.getNumber(_ctx.currentData.FinancialExpense) : '—'), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _hoisted_72,
                        _createElementVNode("span", null, _toDisplayString(_ctx.currentData.OperatingExpense ? _ctx.getNumber(_ctx.currentData.OperatingExpense) : '—'), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _hoisted_73,
                        _createElementVNode("span", null, _toDisplayString(_ctx.currentData.AdministrationExpense ? _ctx.getNumber(_ctx.currentData.AdministrationExpense) : '—'), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("li", _hoisted_74, [
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", null, [
                        _hoisted_75,
                        _createElementVNode("span", null, _toDisplayString(_ctx.currentData.CashEquivalents ? _ctx.getNumber(_ctx.currentData.CashEquivalents) : '—'), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _hoisted_76,
                        _createElementVNode("span", null, _toDisplayString(_ctx.currentData.TradingAssets ? _ctx.getNumber(_ctx.currentData.TradingAssets) : '—'), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _hoisted_77,
                        _createElementVNode("span", null, _toDisplayString(_ctx.currentData.AccountReceivable ? _ctx.getNumber(_ctx.currentData.AccountReceivable) : '—'), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _hoisted_78,
                        _createElementVNode("span", null, _toDisplayString(_ctx.currentData.AdvancePayment ? _ctx.getNumber(_ctx.currentData.AdvancePayment) : '—'), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _hoisted_79,
                        _createElementVNode("span", null, _toDisplayString(_ctx.currentData.OtherReceivable ? _ctx.getNumber(_ctx.currentData.OtherReceivable) : '—'), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _hoisted_80,
                        _createElementVNode("span", null, _toDisplayString(_ctx.currentData.Inventories ? _ctx.getNumber(_ctx.currentData.Inventories) : '—'), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _hoisted_81,
                        _createElementVNode("span", null, _toDisplayString(_ctx.currentData.OtherCurrentAssets ? _ctx.getNumber(_ctx.currentData.OtherCurrentAssets) : '—'), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("li", _hoisted_82, [
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", null, [
                        _hoisted_83,
                        _createElementVNode("span", null, _toDisplayString(_ctx.currentData.HoldForSaleAssets ? _ctx.getNumber(_ctx.currentData.HoldForSaleAssets) : '—'), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _hoisted_84,
                        _createElementVNode("span", null, _toDisplayString(_ctx.currentData.HoldToMaturityInvestments ? _ctx.getNumber(_ctx.currentData.HoldToMaturityInvestments) : '—'), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _hoisted_85,
                        _createElementVNode("span", null, _toDisplayString(_ctx.currentData.LongtermEquityInvest ? _ctx.getNumber(_ctx.currentData.LongtermEquityInvest) : '—'), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _hoisted_86,
                        _createElementVNode("span", null, _toDisplayString(_ctx.currentData.InvestmentProperty ? _ctx.getNumber(_ctx.currentData.InvestmentProperty) : '—'), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _hoisted_87,
                        _createElementVNode("span", null, _toDisplayString(_ctx.currentData.FixedAssets ? _ctx.getNumber(_ctx.currentData.FixedAssets) : '—'), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _hoisted_88,
                        _createElementVNode("span", null, _toDisplayString(_ctx.currentData.ConstruInProcess ? _ctx.getNumber(_ctx.currentData.ConstruInProcess) : '—'), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("li", _hoisted_89, [
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", null, [
                        _hoisted_90,
                        _createElementVNode("span", null, _toDisplayString(_ctx.currentData.IntangibleAssets ? _ctx.getNumber(_ctx.currentData.IntangibleAssets) : '—'), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _hoisted_91,
                        _createElementVNode("span", null, _toDisplayString(_ctx.currentData.DevelopmentExpenditure ? _ctx.getNumber(_ctx.currentData.DevelopmentExpenditure) : '—'), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _hoisted_92,
                        _createElementVNode("span", null, _toDisplayString(_ctx.currentData.GoodWill ? _ctx.getNumber(_ctx.currentData.GoodWill) : '—'), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _hoisted_93,
                        _createElementVNode("span", null, _toDisplayString(_ctx.currentData.LongDeferredExpense ? _ctx.getNumber(_ctx.currentData.LongDeferredExpense) : '—'), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _hoisted_94,
                        _createElementVNode("span", null, _toDisplayString(_ctx.currentData.DeferredTaxAssets ? _ctx.getNumber(_ctx.currentData.DeferredTaxAssets) : '—'), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _hoisted_95,
                        _createElementVNode("span", null, _toDisplayString(_ctx.currentData.OtherNonCurrentAssets ? _ctx.getNumber(_ctx.currentData.OtherNonCurrentAssets) : '—'), 1)
                      ])
                    ])
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_96, [
                _createElementVNode("ul", _hoisted_97, [
                  _createElementVNode("li", _hoisted_98, [
                    _hoisted_99,
                    _createElementVNode("span", null, _toDisplayString(_ctx.currentData.ROEWeighted ? _ctx.currentData.ROEWeighted.toFixed(2)+'%' : '—'), 1)
                  ])
                ]),
                _hoisted_100,
                _createElementVNode("ul", _hoisted_101, [
                  _createElementVNode("li", _hoisted_102, [
                    _hoisted_103,
                    _createElementVNode("span", null, _toDisplayString(_ctx.currentData.ROA ? _ctx.currentData.ROA.toFixed(2)+'%' : '—'), 1)
                  ]),
                  _createElementVNode("li", _hoisted_104, [
                    _hoisted_105,
                    _createElementVNode("span", null, _toDisplayString(_ctx.currentData.NPCOwnersRatio ? _ctx.currentData.NPCOwnersRatio.toFixed(2)+'%' : '—'), 1)
                  ]),
                  _createElementVNode("li", _hoisted_106, [
                    _hoisted_107,
                    _createElementVNode("span", null, _toDisplayString(_ctx.currentData.EquityMultipler ? _ctx.currentData.EquityMultipler.toFixed(2) : '—'), 1)
                  ])
                ]),
                _hoisted_108,
                _createElementVNode("ul", _hoisted_109, [
                  _createElementVNode("li", _hoisted_110, [
                    _hoisted_111,
                    _createElementVNode("span", null, _toDisplayString(_ctx.currentData.OperateNPR ? _ctx.currentData.OperateNPR.toFixed(2)+'%' : '—'), 1)
                  ]),
                  _createElementVNode("li", _hoisted_112, [
                    _hoisted_113,
                    _createElementVNode("span", null, _toDisplayString(_ctx.currentData.TotalAssetTRate ? _ctx.currentData.TotalAssetTRate.toFixed(2)+'次' : '—'), 1)
                  ]),
                  _createElementVNode("li", _hoisted_114, [
                    _hoisted_115,
                    _createElementVNode("span", null, _toDisplayString(_ctx.currentData.DebtAssetsRatio ? _ctx.currentData.DebtAssetsRatio.toFixed(2)+'%' : '—'), 1)
                  ]),
                  _hoisted_116
                ]),
                _hoisted_117,
                _createElementVNode("ul", _hoisted_118, [
                  _createElementVNode("li", _hoisted_119, [
                    _hoisted_120,
                    _createElementVNode("span", null, _toDisplayString(_ctx.currentData.NetProfit ? _ctx.getNumber(_ctx.currentData.NetProfit) : '—'), 1)
                  ]),
                  _createElementVNode("li", _hoisted_121, [
                    _hoisted_122,
                    _createElementVNode("span", null, _toDisplayString(_ctx.currentData.TotalOperatingRevenue ? _ctx.getNumber(_ctx.currentData.TotalOperatingRevenue) : '—'), 1)
                  ]),
                  _createElementVNode("li", _hoisted_123, [
                    _hoisted_124,
                    _createElementVNode("span", null, _toDisplayString(_ctx.currentData.TotalOperatingRevenue ? _ctx.getNumber(_ctx.currentData.TotalOperatingRevenue) : '—'), 1)
                  ]),
                  _createElementVNode("li", _hoisted_125, [
                    _hoisted_126,
                    _createElementVNode("span", null, _toDisplayString(_ctx.currentData.TotalAssets ? _ctx.getNumber(_ctx.currentData.TotalAssets) : '—'), 1)
                  ]),
                  _createElementVNode("li", _hoisted_127, [
                    _hoisted_128,
                    _createElementVNode("span", null, _toDisplayString(_ctx.currentData.TotalLiability ? _ctx.getNumber(_ctx.currentData.TotalLiability) : '—'), 1)
                  ]),
                  _createElementVNode("li", _hoisted_129, [
                    _hoisted_130,
                    _createElementVNode("span", null, _toDisplayString(_ctx.currentData.TotalAssets ? _ctx.getNumber(_ctx.currentData.TotalAssets) : '—'), 1)
                  ]),
                  _hoisted_131
                ]),
                _hoisted_132,
                _createElementVNode("ul", _hoisted_133, [
                  _createElementVNode("li", _hoisted_134, [
                    _createElementVNode("span", null, [
                      _hoisted_135,
                      _createVNode(_component_a_popover, {
                        content: "收入总额=营业总收入+（其他收益+投资收益+汇兑收益+净敞口套期收益+公允价值变动收益+资产处置收益）+营业外收入",
                        trigger: "hover",
                        "arrow-point-at-center": "",
                        placement: "topLeft"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_InfoCircleOutlined, { style: {"margin-left":"6px"} })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("span", null, _toDisplayString(_ctx.currentData.TotalIncome ? _ctx.getNumber(_ctx.currentData.TotalIncome) : '—'), 1)
                  ]),
                  _createElementVNode("li", _hoisted_136, [
                    _createElementVNode("span", null, [
                      _hoisted_137,
                      _createVNode(_component_a_popover, {
                        content: "成本总额=营业总成本+资产减值损失+所得税费",
                        trigger: "hover",
                        "arrow-point-at-center": "",
                        placement: "topLeft"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_InfoCircleOutlined, { style: {"margin-left":"6px"} })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("span", null, _toDisplayString(_ctx.currentData.TotalCost ? _ctx.getNumber(_ctx.currentData.TotalCost) : '—'), 1)
                  ]),
                  _hoisted_138,
                  _hoisted_139,
                  _hoisted_140,
                  _hoisted_141
                ]),
                _createElementVNode("ul", _hoisted_142, [
                  _createElementVNode("li", _hoisted_143, [
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", null, [
                        _hoisted_144,
                        _createElementVNode("span", null, _toDisplayString(_ctx.currentData.NetInterestIncome ? _ctx.getNumber(_ctx.currentData.NetInterestIncome) : '—'), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _hoisted_145,
                        _createElementVNode("span", null, _toDisplayString(_ctx.currentData.NetCommissionIncome ? _ctx.getNumber(_ctx.currentData.NetCommissionIncome) : '—'), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _hoisted_146,
                        _createElementVNode("span", null, _toDisplayString(_ctx.currentData.InvestIncome ? _ctx.getNumber(_ctx.currentData.InvestIncome) : '—'), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _hoisted_147,
                        _createElementVNode("span", null, _toDisplayString(_ctx.currentData.FairValueChangeIncome ? _ctx.getNumber(_ctx.currentData.FairValueChangeIncome) : '—'), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _hoisted_148,
                        _createElementVNode("span", null, _toDisplayString(_ctx.currentData.ExchangeIncome ? _ctx.getNumber(_ctx.currentData.ExchangeIncome) : '—'), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _hoisted_149,
                        _createElementVNode("span", null, _toDisplayString(_ctx.currentData.AssetDealIncome ? _ctx.getNumber(_ctx.currentData.AssetDealIncome) : '—'), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("li", _hoisted_150, [
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", null, [
                        _hoisted_151,
                        _createElementVNode("span", null, _toDisplayString(_ctx.currentData.OperatingTaxSurcharges ? _ctx.getNumber(_ctx.currentData.OperatingTaxSurcharges) : '—'), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _hoisted_152,
                        _createElementVNode("span", null, _toDisplayString(_ctx.currentData.OperatingAndAdminExpense ? _ctx.getNumber(_ctx.currentData.OperatingAndAdminExpense) : '—'), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _hoisted_153,
                        _createElementVNode("span", null, _toDisplayString(_ctx.currentData.AssetImpairmentLoss ? _ctx.getNumber(_ctx.currentData.AssetImpairmentLoss) : '—'), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _hoisted_154,
                        _createElementVNode("span", null, _toDisplayString(_ctx.currentData.IncomeTaxCost ? _ctx.getNumber(_ctx.currentData.IncomeTaxCost) : '—'), 1)
                      ])
                    ])
                  ])
                ])
              ]))
        ], 4),
        _hoisted_155
      ]))
    : (_openBlock(), _createElementBlock("section", _hoisted_156, [
        _createVNode(_component_Nodata, {
          nodatadesc: _ctx.itemdata.title
        }, null, 8, ["nodatadesc"])
      ]))
}